<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <b-link class="brand-logo">
        <b-img
          v-bind="mainProps"
          src="@/assets/images/logo/logo_grupovia.png"
          fluid
        />
      </b-link>

      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5 mt-3"
        >
          <b-img fluid src="@/assets/images/pages/login-v2.png" />
        </div>
      </b-col>
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5 mx-auto"
      >
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title title-tag="h2" class="font-weight-bold mb-1">
            Verificação em 2 etapas
          </b-card-title>

          <b-card-text class="mb-2">
            Digite o código enviado para seu email
          </b-card-text>

          <validation-observer ref="codeValidation">
            <b-form @submit.prevent>
              <b-form-group label="Código" label-for="code">
                <validation-provider
                  #default="{ errors }"
                  name="Código"
                  rules="required|min:6"
                >
                  <b-form-input
                    id="code"
                    maxlength="6"
                    v-model="code"
                    placeholder="Digite o código"
                    @input="handleCodeInput"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <div v-if="error.show" class="text-danger text-center mb-1 mt-1">
                {{ error.text }}
              </div>

              <b-button variant="primary" block @click="validateForm">
                Verificar
              </b-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BButton,
  BLink,
  BFormGroup,
  BFormInput,
  BCardText,
  BCardTitle,
  BImg
} from "bootstrap-vue";

import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, min } from "@validations";
import axios from "axios";
import store from "@/store/index";
import UserService from "@/service/user/user";
import { callLoading } from "@/service/utilities/index";

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BImg,
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BCardText,
    BCardTitle,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      
      code: "",
       mainProps: { width: 270, height: 90, class: 'm2' },
      required,
      min,
      error: {
        show: false,
        text: null,
      },
    };
  },

  methods: {
  handleCodeInput(value) {
    this.code = value.toUpperCase();
  },
   async verifyCode() {
      callLoading(true);

      try {
        const data = JSON.parse(sessionStorage.getItem('2fa_data'))
        const email = data.email

        const verifyResponse = await UserService.verify2FA({
          email,
          secret: this.code,
        });

        if (verifyResponse.status === 401) {
          this.error = {
            show: true,
            text: "Código inválido ou expirado.",
          };
          callLoading(false);
          return;
        }

        if (verifyResponse.status !== 200) {
          this.error = {
            show: true,
            text: "Erro ao validar código.",
          };
          callLoading(false);
          return;
        }
    
        if(!verifyResponse || verifyResponse.status!== 200){
          this.error = {
          show: true,
          text: "Código inválido ou expirado.",
        };
        return;
        }
        
        const response = await UserService.signIn(data.email, data.password)

        const { status, data: loginData } = response

        if (status === 200 && loginData.token) {
          const token = loginData.token

          sessionStorage.setItem("token", token)
          axios.defaults.headers.common['Authorization'] = `Bearer ${token}`

          await store.dispatch("user/fetch")

          sessionStorage.removeItem("2fa_data")

          const redirect = localStorage.getItem("redirectAfterLogin") || "/"
          localStorage.removeItem("redirectAfterLogin")

          this.$router.replace(redirect)
        }

      } catch (e) {
        this.error = {
          show: true,
          text: "Erro ao validar código.",
        };
      }

      callLoading(false);
    },

    validateForm() {
      this.$refs.codeValidation.validate().then((success) => {
        if (success) {
          this.verifyCode();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "@core/scss/vue/pages/page-auth.scss";
</style>
